import http from "@/utils/http";


export const RemoteOpenDoorApi = {
	queryOpenDoorPage(queryForm){
		return http.get('/nexus/acsRemoteOperateLog/page',queryForm);
	}
}